import isEmpty from 'lodash/isEmpty';
import moment from 'moment/moment';
import { useTranslation } from 'react-i18next';

import { Loader, Typography, TYPOGRAPHY_SIZE } from '@thinknet-gmbh/platform-common-ui';

import { useGetWagesAndSalary } from 'src/hooks/wages-and-salary/get-all-wages-and-salary.hook';
import { useUpdateWagesAndSalary } from 'src/hooks/wages-and-salary/update-wages-and-salary.hook';

import { useRouteQuery } from 'src/common/helpers';
import { WagesAndSalaryForm } from '../wages-and-salary-form';

import { MainWrapper } from './wages-and-salary-edit.styles';
import { IWageAndSalaryItem } from '../wages-and-salary.interfaces';

const WagesAndSalaryEdit = ({
  onCancel,
  currentCompanyId,
}: {
  onCancel: () => void;
  currentCompanyId: string;
}) => {
  const { t } = useTranslation(['common', 'employee']);

  const query = useRouteQuery();
  const _id: string = query.get('id') || '';

  const { collection, loading } = useGetWagesAndSalary({
    memberId: _id,
  });

  const { updateWagesAndSalary } = useUpdateWagesAndSalary({
    onSuccess: onCancel,
  });

  const onFinish = ({ salaries }: { salaries: IWageAndSalaryItem[] }) => {
    updateWagesAndSalary({
      variables: {
        payload: {
          salaries: salaries,
          companyId: currentCompanyId,
          memberId: _id,
        },
      },
    });
  };

  if (loading) {
    return <Loader />;
  }

  const salaries = collection?.map((el: IWageAndSalaryItem) => {
    return {
      ...el,
      startDate: el?.startDate ? moment(el?.startDate) : null,
    };
  });

  return (
    <MainWrapper>
      <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
        {t('employee:wagesAndSalary.labels.wagesAndSalary')}
      </Typography>
      <WagesAndSalaryForm
        onFinish={onFinish}
        onCancel={onCancel}
        initialValues={{
          salaries: isEmpty(salaries) ? [{}] : salaries,
        }}
      />
    </MainWrapper>
  );
};

export default WagesAndSalaryEdit;
